module.exports = __webpack_public_path__ + "static/media/register_vplus.c3a955e4.png";